module.exports = __webpack_public_path__ + "img/9.9bc6552c.jpg";